import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ConfirmationService } from 'primeng/api';
import { TimesheetBreakdownRule } from '../shared/models/timesheet-breakdown-rule';

@Component({
  selector: 'pps-breakdown-rule-lock',
  template: `
    <span>
      <a *ngIf="lock" class="action-icon text-danger" (click)="toggleLock($event)" href="#">
        <i class="fas fa-lock fa-lg" alt="lock" pTooltip="Click to unlock the rule for modifying" tooltipPosition="bottom"></i>
      </a>
      <a *ngIf="!lock" class="action-icon text-success" (click)="toggleLock($event)" href="#">
        <i class="fas fa-unlock fa-lg" alt="unlock" pTooltip="Click to lock the rule" tooltipPosition="bottom"></i>
      </a>
    </span>
  `,
  styles: [
  ],
})
export class BreakdownRuleLockComponent implements AgRendererComponent {
  params: ICellRendererParams;
  lock: boolean = true;

  constructor(private _confirmationService: ConfirmationService){}
  
  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.lock = params.data.lock;
  }

  afterGuiAttached?(params?: import("ag-grid-community").IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  toggleLock(evt){
    evt.preventDefault();
    let currentRuleId = this.params.data.id;
    var foundIndex = this.params.context.componentParent.rules.findIndex(x => x.id == currentRuleId);
    if (foundIndex === -1){
      console.log("Weird");
      return;
    }

    let oldRule = this.params.context.componentParent.rules[foundIndex];
    
    let errorMessages = [];
    if (oldRule.position === null){
      errorMessages.push("You must select a job position.");
    }
    if (oldRule.rosterCode === null){
      errorMessages.push("You must select a roster code.");
    }
    if (oldRule.payCategory === null){
      errorMessages.push("You must select a pay categoy.");
    }
    if (oldRule.breakdownRule === null){
      errorMessages.push("You must select a hour calculation rule.");
    }
    if (errorMessages.length > 0){
      this._confirmationService.confirm({
        header: "You cannot lock the rule",
        message: `Please fix the following errors before you lock the rule:<br /> ${errorMessages.join("<br />")}`,
        icon: "pi pi-ban text-danger",
        key: "dlg2",
        acceptVisible: true,
        acceptLabel: "Ok",
        rejectVisible: false
      });
      return;
    }

    this.lock = !this.lock;
    let rule = new TimesheetBreakdownRule();
    rule.id = currentRuleId;
    rule.lock = this.lock;

    this.params.context.componentParent.updateRule(rule, "lock", null, null, null, null);
  }
}

